import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const receptionistApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/receptionist",
      params,
    }),
  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/receptionist",
      data,
      method: "post",
    }),
  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/receptionist/${id}`,
      method: "patch",
      data,
    }),
  resetPassword: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/receptionist/${id}/password/reset`,
      method: "patch",
      data,
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/receptionist/${id}`,
      method: "delete",
    }),
};
